import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function ConfirmReviewDialog({
  children,
  onConfirm,
}: {
  children: React.ReactNode
  onConfirm: () => void
}) {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[425px] rounded-2xl">
        <DialogHeader>
          <DialogTitle>{t('checklists.checklistNotFinished')}</DialogTitle>
          <DialogDescription>
            {t('checklists.checklistNotFinishedDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="!justify-between gap-2">
          <Button
            variant="secondary"
            type="button"
            onClick={() => setOpen(false)}
          >
            {t('back')}
          </Button>
          <Button type="button" onClick={onConfirm}>
            {t('checklists.finish')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
